import {
    FormControlLabel,
    Paper, Select, Switch, withStyles
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { contextsActions } from '../../../actions/contextsActions';
import { disallowedPeriodsActions } from '../../../actions/disallowedPeriodsActions';
import { municipalitiesActions } from '../../../actions/municipalitiesActions';
import { ratesActions } from '../../../actions/ratesActions';
import translate from '../../../locales';
import {
    APP_CLAIMS, freeDayReference, hasPermission, pageModes, productTypes, styleWithCommonClasses,
    tabDisplays
} from '../../../_constants/emparkConstants';
import { toDateObjectFromJson, toDateString } from '../../../_helpers/dateConvert';
import ConfirmDialog from '../../Dialogs/ConfirmDialog';
import ErrorDialog from '../../Dialogs/ErrorDialog';
import LoadingPaper from '../../LoadingPaper';
import EMTable from '../../Tables/EMTable';




const __t = translate;

const styles = styleWithCommonClasses();

const DisallowedPeriodsTablePage = props => {
    const [confirmModal, setConfirmModal] = useState(false);

    /* Events */
    const handleDelete = (disallowedPeriod) => {
        props.deleteDisallowedPeriod(props.reference, props.referenceId, disallowedPeriod.id);
    }

    const onEditAndDeleteCondition = disallowedPeriod => {
        let isEditable = true;

        if (props.reference === freeDayReference.context) {
            isEditable = disallowedPeriod.contextId != null;
        }
        else if (props.reference === freeDayReference.rate) {
            isEditable = disallowedPeriod.rateId != null;
        }

        return isEditable;
    }

    /* Render */
    const { classes, reference, isOverwrite } = props;

    if (props.loading)
        return (
            <LoadingPaper />
        )

    let disallowedPeriods = [];
    if (reference === freeDayReference.municipality)
        disallowedPeriods = props.disallowedPeriods.municipality;
    else if (reference === freeDayReference.context)
        disallowedPeriods = props.disallowedPeriods.context;
    else
        disallowedPeriods = props.disallowedPeriods.rate;

    const rowsDisallowedPeriodsTable = [
        {
            id: 'fromDate', align: 'center', disablePadding: false, label: `${__t('valid_from')} ${__t('inclusive_helper')}`, formatter: function (value) {
                return toDateString(toDateObjectFromJson(value))
            }
        },
        {
            id: 'toDate', align: 'center', disablePadding: false, label: `${__t('valid_to')} ${__t('exclusive_helper')}`, formatter: function (value) {
                return toDateString(toDateObjectFromJson(value))
            }
        },
    ];

    const isPrebooks = props.productTypeCode == productTypes.prebooks;

    return (
        <Paper
            style={{ position: 'relative' }}
            className={classes.paperNoMargins}
            elevation={0}
        >

            <ErrorDialog
                error={props.error}
                onOkClick={() => props.setError(null)}
            />
            <ConfirmDialog
                open={confirmModal}
                title={isOverwrite ? __t('stop_apply_exception') : __t('apply_exception')}
                content={__t('msg_overwrite_disallowed_periods_description')}
                onClose={(action) => {
                    setConfirmModal(false);

                    if (action == 'ok') {
                        props.updateOverwrite(props.referenceId, !isOverwrite);
                    }
                }}
            />
            <EMTable
                tableTitle={`${props.productTypeCode == productTypes.prebooks ? __t('disallowed_periods') : __t('disallowed_periods_purchase')}`}
                dataSource={disallowedPeriods}
                rows={rowsDisallowedPeriodsTable}
                onAdd={hasPermission(props.userRole, APP_CLAIMS.DIS_C) && !isPrebooks && (reference === freeDayReference.municipality || isOverwrite) && (() => {
                    props.changeTabDisplay(props.reference, tabDisplays.secondary);
                    props.changeMode(pageModes.add);
                })}
                onEdit={(disallowedPeriod) => {
                    props.changeTabDisplay(props.reference, tabDisplays.secondary);
                    props.changeMode(pageModes.edit, disallowedPeriod.id);
                }}
                onEditCondition={(disallowedPeriod) => !isPrebooks && hasPermission(props.userRole, APP_CLAIMS.DIS_E) && (reference === freeDayReference.municipality || isOverwrite) && onEditAndDeleteCondition(disallowedPeriod)}
                onDelete={handleDelete}
                onDeleteCondition={(disallowedPeriod) => !isPrebooks && hasPermission(props.userRole, APP_CLAIMS.DIS_D) && (reference === freeDayReference.municipality || isOverwrite) && onEditAndDeleteCondition(disallowedPeriod)}
                filterComponent={typeof isOverwrite === 'undefined' || isPrebooks ?
                    null
                    :
                    <FormControlLabel
                        style={{ border: '1px solid grey', paddingRight: '15px' }}
                        control={
                            <Switch
                                checked={isOverwrite}
                                onChange={() => setConfirmModal(true)}
                                disabled={!hasPermission(props.userRole, APP_CLAIMS.DIS_C)}
                            />
                        }
                        label={__t('apply_exception')}
                    />
                }
            />
        </Paper>
    )
}

function mapStateToProps(state) {
    return {
        router: state.disallowedPeriodsReducer.router,
        disallowedPeriods: state.disallowedPeriodsReducer.disallowedPeriods,
        reference: state.disallowedPeriodsReducer.reference,
        referenceId: state.disallowedPeriodsReducer.referenceId,
        error: state.disallowedPeriodsReducer.error,
        userRole: state.usersReducer.userRole,
        loading: state.disallowedPeriodsReducer.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        deleteDisallowedPeriod: (reference, referenceId, freeDayId) => {
            dispatch(disallowedPeriodsActions.deleteDisallowedPeriod(reference, referenceId, freeDayId))
        },
        changeMode: (mode, id) => {
            dispatch(disallowedPeriodsActions.changeMode(mode, id))
        },
        changeTabDisplay: (reference, tabDisplay) => {
            if (reference === freeDayReference.municipality)
                dispatch(municipalitiesActions.setTabDisplay(tabDisplay))
            else if (reference === freeDayReference.context)
                dispatch(contextsActions.setTabDisplay(tabDisplay))
            else
                dispatch(ratesActions.setTabDisplay(tabDisplay))
        },
        setError: (error) => {
            dispatch(disallowedPeriodsActions.setError(error))
        },
        updateOverwrite: (rateId, isOverwrite) => {
            dispatch(ratesActions.updateOverwrite(rateId, false, isOverwrite));
        }
    }
}

DisallowedPeriodsTablePage.propTypes = {
    reference: PropTypes.string,
    referenceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    router: PropTypes.object,
    specialdays: PropTypes.array,
    error: PropTypes.string,
    fetchDisallowedPeriods: PropTypes.func,
    changeMode: PropTypes.func,
    isOverwrite: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DisallowedPeriodsTablePage));